import { HttpInterceptorFn } from "@angular/common/http";
import { inject } from "@angular/core";
import { Subscription } from "rxjs";
import { finalize } from "rxjs/operators";
import { SpinnerOverlayService } from "../components/spinner-overlay/spinner-overlay.service";

export const loaderInterceptor: HttpInterceptorFn = (req, next) => {
    const loaderService = inject(SpinnerOverlayService);
    const spinnerSubscription: Subscription = loaderService.spinner$.subscribe();
    return next(req).pipe(finalize(() => spinnerSubscription.unsubscribe()));
};
